import {
  Box,
  Text,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Grid,
  GridItem,
  Flex,
  Button,
  Image,
  Center,
  Icon,
} from '@chakra-ui/react'
import {CommonColors} from '@utils/CommonStyles'
import CardTopic from '@components/CardTopic'
import {Progress} from 'antd'
import {ReactComponent as ArrowRight} from '@assets/svgs/learn/arrow_right_3.svg'
import {useEffect, useState} from 'react'
import PracticeExam from '@pages/ExamPage/components/PracticeExam'
import NoteBookCard from './components/NotebookCard'
import {useNavigate} from 'react-router-dom'
import {PATH} from '@utils/Const'
import {isLoggedIn} from '@utils'
import appRequest from '@apis/app'
import AvatarFull from '@assets/images/learn/avatar_full_body_opacity.png'
import reviseRequest from '@apis/revise'

const LearnPage = () => {
  const [LearnPageData, setLearnPageData] = useState<any>(null)
  const [forecastSet, setForecastSet] = useState<any>(null)
  const [quantities, setQuantities] = useState<any>(null)

  const navigate = useNavigate()

  useEffect(() => {
    const getLearnPageData = async () => {
      try {
        const res = await appRequest.getTopicOverview()
        setLearnPageData(res?.data?.data)
      } catch (error) {}
    }
    getLearnPageData()
  }, [])

  useEffect(() => {
    const getForecastSet = async () => {
      try {
        const res = await appRequest.getForecastSet()
        setForecastSet(res?.data?.data)
      } catch (error) {}
    }

    getForecastSet()
  }, [])

  useEffect(() => {
    const getQuantities = async () => {
      try {
        const res = await reviseRequest.getQuantities()
        setQuantities(res?.data?.data)
      } catch (error) {}
    }

    getQuantities()
  }, [])

  const handleNavigateToLesson = (
    feature: string,
    thumbnail: string,
    topic = '',
    title = '',
  ) => {
    navigate(PATH.LESSON_LEARN, {
      state: {
        feature: feature,
        thumbnail: thumbnail,
        topic,
        title,
      },
    })
  }

  const handleClickTopic = (
    feature: string,
    thumbnail: string,
    topic = '',
    title = '',
  ) => {
    if (!isLoggedIn()) return navigate(PATH.LOGIN)
    if (feature === 'LESSON_PART_TWO') {
      return
    }
    handleNavigateToLesson(feature, thumbnail, topic, title)
  }

  const renderHeader = () => (
    <Box bg={CommonColors.white} p={{base: '16px', md: '32px'}}>
      <Box maxW={'1400px'} mx={'auto'}>
        <Text fontSize={{base: '24px', md: '32px'}} fontWeight={'600'}>
          Luyện tập theo chủ đề
        </Text>
        <Text
          fontSize={{base: '14px', md: '16px'}}
          color={'#7C7C7C'}
          mt={'16px'}>
          Luyện IELTS speaking theo từng chủ đề phổ biến và bộ đề mới nhất theo
          lựa chọn của bạn
        </Text>
      </Box>
    </Box>
  )

  const renderTabList = () => (
    <Box px={{base: '16px', md: '32px'}} bg={CommonColors.white}>
      <TabList borderBottom={'none'} maxW={'1400px'} mx={'auto'}>
        <Tab
          fontSize={'16px'}
          px={{base: '16px', md: '24px'}}
          _selected={{
            color: CommonColors.primary,
            bg: '#f5f5f5',
            borderRadius: '8px 8px 0 0',
            fontWeight: '700',
          }}>
          Sổ tay kiến thức
        </Tab>
        <Tab
          fontSize={'16px'}
          px={{base: '16px', md: '24px'}}
          _selected={{
            color: CommonColors.primary,
            bg: '#f5f5f5',
            borderRadius: '8px 8px 0 0',
            fontWeight: '700',
          }}>
          Theo câu
        </Tab>
        <Tab
          fontSize={'16px'}
          px={{base: '16px', md: '24px'}}
          _selected={{
            color: CommonColors.primary,
            bg: '#f5f5f5',
            borderRadius: '8px 8px 0 0',
            fontWeight: '700',
          }}>
          Bộ đề
        </Tab>
      </TabList>
    </Box>
  )

  const renderBySentenceTab = () => {
    return (
      <Box>
        <Text fontSize={'16px'} color={'#7C7C7C'}>
          Lưu trữ và giúp bạn ôn luyện câu, cụm từ quan trọng nhất
        </Text>
        <Box
          mt={'24px'}
          bg={'white'}
          p={{base: '16px', md: '32px'}}
          borderRadius={'16px'}>
          <Flex justifyContent={'space-between'} alignItems={'center'}>
            <Text fontSize={{base: '16px', md: '24px'}} fontWeight={'600'}>
              Luyện Part 1
            </Text>
            <Button
              fontSize={{base: '14px', md: '16px'}}
              variant={'outline'}
              color={CommonColors.primary}
              borderColor={CommonColors.primary}
              px={{base: '16px', md: '24px'}}
              onClick={() => {
                handleNavigateToLesson(
                  LearnPageData?.topic_part_1?.feature,
                  LearnPageData?.topic_part_1?.topics[0]?.thumbnail,
                  LearnPageData?.topic_part_1?.topics[0]?.text_en,
                )
              }}>
              Xem thêm
            </Button>
          </Flex>
          <Grid
            templateColumns={{
              base: 'repeat(1, 1fr)',
              lg: 'repeat(2, 1fr)',
              xl: 'repeat(3, 1fr)',
            }}
            gap={{base: '16px', md: '32px'}}
            mt={{base: '16px', md: '32px'}}>
            {LearnPageData?.topic_part_1?.topics?.map(
              (topic: any, index: any) => (
                <GridItem key={index}>
                  <CardTopic
                    title={topic.text_en}
                    subtitle={topic.text_vi}
                    image={topic.thumbnail}
                    totalLesson={topic.total_lesson}
                    completedLesson={topic.completed_lesson}
                    progress={topic.progress_percentage}
                    onClick={() => {
                      handleClickTopic(
                        LearnPageData?.topic_part_1?.feature,
                        topic.thumbnail,
                        topic.text_en,
                      )
                    }}
                  />
                </GridItem>
              ),
            )}
          </Grid>
        </Box>
        <Box
          bg={'white'}
          p={{base: '16px', md: '32px'}}
          borderRadius={'16px'}
          mt={'32px'}>
          <Flex justifyContent={'space-between'} alignItems={'center'}>
            <Text fontSize={{base: '16px', md: '24px'}} fontWeight={'600'}>
              Luyện Part 2
            </Text>
            <Button
              fontSize={{base: '14px', md: '16px'}}
              variant={'outline'}
              color={CommonColors.primary}
              borderColor={CommonColors.primary}
              px={{base: '16px', md: '24px'}}
              onClick={() => {
                handleNavigateToLesson(
                  LearnPageData?.topic_part_2?.feature,
                  LearnPageData?.topic_part_2?.topics[0]?.thumbnail,
                  LearnPageData?.topic_part_2?.topics[0]?.text_en,
                )
              }}>
              Xem thêm
            </Button>
          </Flex>
          <Grid
            templateColumns="repeat(1, 1fr)"
            gap={{base: '16px', md: '32px'}}
            mt={{base: '16px', md: '32px'}}>
            {LearnPageData?.topic_part_2?.topics?.map(
              (topic: any, index: any) => (
                <GridItem
                  key={index}
                  onClick={() => {
                    navigate(PATH.LEARN_PART_TWO, {
                      state: {
                        lesson_id: topic?.lesson_id,
                      },
                    })
                  }}>
                  <Flex
                    gap={{base: '16px', md: '24px'}}
                    alignItems={'center'}
                    borderRadius="12px"
                    border="2px solid #f3f3f3"
                    p={{base: '16px', md: '20px'}}
                    cursor={'pointer'}
                    _hover={{
                      border: '2px solid #8ED4FF',
                      boxShadow: '0px 4px 0px 0px #8ED4FF',
                    }}>
                    <Center
                      flexShrink={0}
                      w={{base: '50px', md: '85px'}}
                      h={{base: '50px', md: '85px'}}
                      borderRadius={'50%'}
                      overflow={'hidden'}
                      bg={'linear-gradient(180deg, #EEF8FF 0%, #f5f5f5 100%)'}>
                      <Image
                        w={'100%'}
                        h={'100%'}
                        objectFit={'cover'}
                        src={topic.thumbnail || AvatarFull}
                      />
                    </Center>
                    <Flex flexDirection={'column'} gap={'10px'}>
                      <Text color={CommonColors.primary}>
                        {topic.topic_name}
                      </Text>
                      <Text
                        fontSize={{base: '14px', md: '16px'}}
                        fontWeight={'600'}>
                        {topic.text_en}
                      </Text>
                      <Text
                        fontSize={'12px'}
                        fontWeight={'500'}
                        color={'#989898'}>
                        {topic.text_vi}
                      </Text>
                      <Progress
                        percent={topic?.progress_percentage}
                        strokeColor={CommonColors.primary}
                        showInfo={false}
                        size={[200, 8]}
                      />
                    </Flex>
                    <Icon
                      w={'30px'}
                      h={'30px'}
                      as={ArrowRight}
                      stroke={'#BDBDBD'}
                      ml={'auto'}
                    />
                  </Flex>
                </GridItem>
              ),
            )}
          </Grid>
        </Box>
        <Box
          bg={'white'}
          p={{base: '16px', md: '32px'}}
          borderRadius={'16px'}
          mt={'32px'}>
          <Flex justifyContent={'space-between'} alignItems={'center'}>
            <Text fontSize={{base: '16px', md: '24px'}} fontWeight={'600'}>
              Luyện Part 3
            </Text>
            <Button
              fontSize={{base: '14px', md: '16px'}}
              variant={'outline'}
              color={CommonColors.primary}
              borderColor={CommonColors.primary}
              px={{base: '16px', md: '24px'}}
              onClick={() => {
                handleNavigateToLesson(
                  LearnPageData?.topic_part_3?.feature,
                  LearnPageData?.topic_part_3?.topics[0]?.thumbnail,
                  LearnPageData?.topic_part_3?.topics[0]?.text_en,
                )
              }}>
              Xem thêm
            </Button>
          </Flex>
          <Grid
            templateColumns={{
              base: 'repeat(1, 1fr)',
              lg: 'repeat(2, 1fr)',
              xl: 'repeat(3, 1fr)',
            }}
            gap={{base: '16px', md: '32px'}}
            mt={{base: '16px', md: '32px'}}>
            {LearnPageData?.topic_part_3?.topics?.map(
              (topic: any, index: any) => (
                <GridItem key={index}>
                  <CardTopic
                    title={topic.text_en}
                    subtitle={topic.text_vi}
                    image={topic.thumbnail}
                    completedLesson={topic.completed_lesson}
                    totalLesson={topic.total_lesson}
                    progress={topic.progress_percentage}
                    onClick={() => {
                      handleClickTopic(
                        LearnPageData?.topic_part_3?.feature,
                        topic.thumbnail,
                        topic.text_en,
                      )
                    }}
                  />
                </GridItem>
              ),
            )}
          </Grid>
        </Box>
      </Box>
    )
  }

  const renderNoteBookTab = () => (
    <Box>
      <Text fontSize={'16px'} color={'#7C7C7C'}>
        Lưu trữ và giúp bạn ôn luyện câu, cụm từ quan trọng nhất
      </Text>
      <Flex mt={'24px'} gap={'24px'} flexDirection={'column'}>
        <NoteBookCard
          type={'PHRASE'}
          isDisable={quantities?.phrase_quantity === 0}
        />
        <NoteBookCard
          type={'SENTENCE'}
          isDisable={quantities?.sentence_quantity === 0}
        />
      </Flex>
    </Box>
  )

  const renderByTopicTab = () => (
    <Box>
      <Text fontSize={'16px'} color={'#7C7C7C'}>
        Lưu trữ và giúp bạn ôn luyện câu, cụm từ quan trọng nhất
      </Text>
      <Box
        borderRadius={'16px'}
        p={{base: '16px', md: '32px'}}
        bg={CommonColors.white}
        mt={{base: '16px', md: '24px'}}>
        <Text
          fontSize={{base: '16px', md: '24px'}}
          fontWeight={'600'}
          mb={{base: '16px', md: '32px'}}>
          Luyện thi theo bộ đề
        </Text>
        <PracticeExam data={forecastSet} type={'LEARN'} />
      </Box>
    </Box>
  )

  return (
    <Box pt={{base: '16px', md: 0}}>
      {renderHeader()}
      <Tabs defaultIndex={1}>
        {renderTabList()}
        <Box p={{base: '16px', md: '32px'}}>
          <TabPanels maxW={'1400px'} mx={'auto'}>
            <TabPanel p={0}>{renderNoteBookTab()}</TabPanel>
            <TabPanel p={0}>{renderBySentenceTab()}</TabPanel>
            <TabPanel p={0}>{renderByTopicTab()}</TabPanel>
          </TabPanels>
        </Box>
      </Tabs>
    </Box>
  )
}

export default LearnPage
